<template>
  <div class="bigbox">
    <div class="page_banner">
      <div class="pic" style></div>
      <div class="pos">
        <b>Contact Us</b>
        <p>联系我们</p>
      </div>
    </div>

    <div class="mapbox">
      <div class="mapbigbox">
        <div class="map" style="float:left;border: 1px solid #ddd;">
          <baidu-map
            :style="{width:map.width,height:map.height}"
            class="map"
            :zoom="map.zoom"
            :center="{lng: map.center.lng, lat: map.center.lat}"
            :scroll-wheel-zoom="true"
          >
            <!--比例尺控件-->
            <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
            <!--缩放控件-->
            <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
            <bm-marker v-for="item in list" :key="item.id"
              :position="{lng: item.lng, lat: item.lat}"
              :dragging="false"
            >
              <bm-label
                :content="item.name"
                :labelStyle="{fontSize : '16px'}"
                :offset="{width: -125, height: 15}"
              />
            </bm-marker>
            <!-- <bm-marker
              :position="{lng: shenzhenPos.lng, lat: shenzhenPos.lat}"
              :dragging="false"
            >
              <bm-label
                content="武汉汇迪森信息技术有限公司-深圳办事处"
                :labelStyle="{fontSize : '16px'}"
                :offset="{width: -145, height: 15}"
              />
            </bm-marker> -->
          </baidu-map>
        </div>
        <div class="posright">
          <div v-for="(item, index) in list" :key="item.id" class="pos clearfix" :class="posborder == index?'active':''" 
            @click="checkdepos(index)">
            <div class="t">{{item.name}}</div>
            <dl class="clearfix">
              <dt class="dt2">业务联系电话：</dt>
              <dd>{{item.mobile}}</dd>
            </dl>
            <dl class="clearfix">
              <dt class="dt3">传真：</dt>
              <dd>{{item.fax}}</dd>
            </dl>
             <dl class="clearfix">
              <dt class="dt1">地址：</dt>
              <dd>{{item.address}}</dd>
            </dl>
          </div>
          <!-- <div class="pos clearfix " :class="posborder==2?'active':''" @click="checkdepos(2)">
            <div class="t">武汉汇迪森信息技术有限公司-深圳办事处</div>
              <dl class="clearfix">
              <dt class="dt2">业务联系电话：</dt>
              <dd>027-86659180 86659183</dd>
            </dl>
            <dl class="clearfix">
              <dt class="dt3">传真：</dt>
              <dd>027-86659150</dd>
            </dl>
              <dl class="clearfix">
              <dt class="dt1">地址：</dt>
              <dd>深圳市南山区桃园路147号南景苑23C</dd>
            </dl>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { fetchList } from '@/api/contactAddress'
import iconCar from '../assets/pos.png'; //以import的方式导入图片文件
export default {
  name: "",
  data() {
    return {
      map: {
        // 114.415999,30.461963
        // 113.927135,22.537631
        center: {},
        zoom: 19,
        width: "100%",
        height: "100%",
      },
      // wuhanPos: { lng: 114.415999, lat: 30.461963 },
      show: true,
      posborder: 0,
      // shenzhenPos: {lng: 113.927135, lat: 22.537631},
      list: []
    };
  },
  methods: {
    checkdepos(e){
      this.posborder = e
      this.map.center = {lng: this.list[this.posborder].lng, lat: this.list[this.posborder].lat}
    },
    getContactAddressList() {
      fetchList().then(res => {
        if (res.code !== 200) return
        this.list = res.data
        this.map.center = {lng: this.list[this.posborder].lng, lat: this.list[this.posborder].lat}
      })
    }
  },
  created () {
    this.map.center = this.wuhanPos
    this.getContactAddressList()
  }
};
</script>

<style scoped >
@media screen and (max-width: 760px) {
  .bigbox .page_banner {
    height: 150px;
  }
}
.page_banner {
  position: relative;
  height: 455px;
  overflow: hidden;
  background: url();
}
.page_banner .pic {
  width: 100%;
  height: 100%;
  background: url(../assets/Contact_Us.jpg) center no-repeat;
  background-size: cover;
  -webkit-animation-duration: 18s;
  animation-duration: 18s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: bg_pic;
  animation-name: bg_pic;
}
@keyframes bg_pic {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.page_banner .pos {
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -43px;
  width: 100%;
  text-align: center;
  animation-delay: 0s;
  -webkit-animation-duration: 0.8s;
  animation-duration: 0.8s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
@media screen and (max-width: 760px) {
  .bigbox .page_banner .pos b {
    font-size: 25px;
  }
}
@media screen and (max-width: 760px) {
  .bigbox .page_banner .pos p {
    font-size: 20px;
  }
}
@media screen and (max-width: 760px) {
  .bigbox .page_banner .pos {
    margin-top: -25px;
  }
}
.page_banner .pos b {
  font-size: 42px;
  color: #fff;
  font-weight: bold;
  font-family: "Arial";
}
.page_banner .pos p {
  font-size: 28px;
  color: #fff;
}

.mapbox {
  width: 100%;
  height: auto;
  margin-top: 10px;
  position: relative;
}
@media screen and (max-width: 1300px) {
  div.mapbigbox {
   width:100%;
   padding:0;
  }
}
.mapbigbox {
  overflow: hidden;
  width: 1280px;
  margin: 0 auto;
  padding: 100px 0;
}
@media screen and (max-width: 760px) {
  div.mapbox .map {
   height: 300px;
    width: 100%;
    margin:0 auto;
  }
}
.mapbox .map {
  background-color: #000;
  z-index: 1;
  width: 48%;
  height: 460px;
}

@media screen and (max-width: 760px) {
  div.mapbox .posright {
    width: 100%;
    margin:0 auto;
  }
}
.posright{
  float:right;
  width:48%;
}
.mapbox .pos {
  padding: 30px 5%;
  width: 100%;
  height: 220px;
  border:1px solid #eee;
  box-sizing: border-box;
  /* background: rgba(0, 109, 184, 0.8); */
  background: rgba(255, 255, 255, 0.94);
}
@media screen and (max-width: 760px) {
  div.mapbox .pos:nth-child(2){
  margin-top: 0;
}
}
.mapbox .pos:nth-child(2){
  margin-top: 20px;
}
@media screen and (max-width: 1280px) {
  .mapbox .pos {
    right: 0;
  }
}
@media screen and (max-width: 760px) {
  div.mapbox .pos {
    padding:20px 3%;
    height: 180px;
    border-top:0 ;
     border-left:0 ;
      border-right:0 ;
  }
}
.clearfix {
  zoom: 1;
}
.pos.active{
  border-color: #146cbd;
}
@media screen and (max-width: 760px) {
  .mapbox .pos .t {
    font-size: 18px !important;
    line-height: 30px !important;
    margin-bottom: 5px !important;
  }
}
.mapbox .pos .t {
  margin-bottom: 20px;
  line-height: 34px;
  font-size: 24px;
  /* color: #fff; */
  border-bottom: #fff 1px solid;
}
@media screen and (max-width: 760px) {
  .mapbox .pos dl {
    font-size: 12px !important;
    line-height: 28px !important;
    margin-bottom: 0px !important;
  }
}
.mapbox .pos dl {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 20px;
}

.mapbox .pos dt {
  float: left;
  color: #aaa;
}

.mapbox .pos dd {
  float: left;
  /* color: #fff; */
}
</style>




// WEBPACK FOOTER //
// src/pages/contactUs.vue